// Modelo Marca para administrador
export default class Menu {
    id=""
    icon=""
    title=""
    route=""
    description=""
  }
  


// WEBPACK FOOTER //
// ./src/model/Menu.js